import {
  SELECTION_FETCHED,
  SELECTION_DETAIL_FETCHED,
  SELECTION_PHOTOS_FETCHED,
  SELECTION_FETCHED_ERROR,
} from '../actions/Selection.js';

export default (state = {
  list: [],
  firms: [],
  characters: [],
  images: [],
}, action) => {
  switch (action.type) {
    case SELECTION_FETCHED_ERROR:
      return Object.assign({}, state, {
        list: [],
      });
      
    case SELECTION_FETCHED:
      return Object.assign({}, state, {
        list: action.list,
      });

    case SELECTION_DETAIL_FETCHED:
      return Object.assign({}, state, {
        firms: action.firms,
        characters: action.characters,
      });

    case SELECTION_PHOTOS_FETCHED:
      return Object.assign({}, state, {
        images: action.list,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Selection.js